import Preparation from "./Preparation";

export default Preparation;
